import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";
import { lookupRayWhiteOffice, suburbPostcodeKey } from "./offices.ts";

/**
 * Ray White has no national sold-listings rollup — every office runs its
 * own subdomain. Resolve the office for the suburb via the static map in
 * offices.ts and return its `/properties/sold-residential` page. A suburb
 * without a mapping throws; the discovery worker surfaces the error in
 * `discovery_tasks.error_message` and the missing entry can be added.
 */
export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  const entry = lookupRayWhiteOffice(suburb);
  if (!entry) {
    throw new Error(
      `Ray White: no office mapping for suburb ${suburbPostcodeKey(suburb)} — add it to OFFICE_BY_SUBURB_POSTCODE in ray-white/offices.ts`,
    );
  }
  return `https://${entry.office}/properties/sold-residential`;
}
